import { useMemo } from 'react';
import { Theme } from '@streem/ui-react';

const levelIndicators = Array(15).fill(0);

// Responsible for applying the correct color if the inidcators based on audio level,
// audio level can range from 0-10. We want the first 6 indicators to have a light blue color,
// the next 5 to be slightly darker and the last 4 to be even darker. We achieve this by
// changing the percentage of the color lightness with some math.

export const useGetAudioLevelGradient = (audioLevel: number) => {
    return useMemo(() => {
        const activeBars = Math.round((audioLevel / 10) * levelIndicators.length);
        return levelIndicators.map((_, index) => {
            if (index < activeBars) {
                const lightness = 90 - (index / levelIndicators.length) * 40;
                return `hsl(210, 100%, ${lightness}%)`;
            }
            return Theme.colors.grey30;
        });
    }, [audioLevel]);
};
